import {
  Backdrop,
  Box,
  Button,
  Grid,
  Switch,
  TextField,
  Tooltip,
  Typography,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { GridRowModel } from "@mui/x-data-grid-pro";
import { useFormik } from "formik";
import moment from "moment";
import { getPrintFile } from "src/app-redux/common-actions";
import { useAppSelector } from "src/app-redux/hooks";
import { loader as gateEntryLoader } from "src/app-redux/gate-entry/gateEntrySlice";
import {
  selectInventoryItemStatusListing,
  selectWareHouseListing,
} from "src/app-redux/warehouse/wareHouseSlice";
import CommonDataGridPage from "src/components/CommonDataGridPage/CommonDataGridPage";
import { NodWereHouseRoute } from "../../nod-were-house.routes";
import { columns } from "./components/columns";
import { useStyles } from "./style";
import CommonMaterialGrid from "src/components/CommonXGrid/CommonMaterialGrid";
import { fetchWrapper } from "src/api-client/fetchWrapper";
import CommonAutoCompleteField from "src/components/CommonAutoCompleteField/CommonAutoCompleteField";
import { addNotificationAction } from "src/app-redux/settings/settingsSlice";
import { object, string } from "yup";
import CommonLoader from "src/components/Loader/CommonLoader";
import { Edit } from "@material-ui/icons";
// TransitionDialog removed for inline editing
import NewCommonButton from "src/components/CommonButton/NewCommonButton";
import CommonTextFieldDate from "src/components/CommonTextFieldForDate/CommonTextFieldDate";
import {
  getInventoryItemStatusListingAction,
  getWareHouseListingAction,
} from "src/app-redux/warehouse/actions/wareHouseActions";
import { getAllShads } from "src/app-redux/configuration/actions/configurationActions";
import { selectAllShadList } from "src/app-redux/configuration/configurationSlice";
import { IconButton } from "@mui/material";
import Info from "@material-ui/icons/Info";
import TransitionDialog from "src/components/AlertDialog/TransitionDialog";
import DuplicateReceiptDialog from "src/components/AlertDialog/DuplicateReceiptDialog";

interface Props {}

export function DestuffingItems({}: Props): React.ReactElement {
  const isExportString = localStorage.getItem("isAllowToExportData");
  const isExport = isExportString === "true";
  const classes = useStyles();
  const destuffDatePickerRef = React.useRef<any>(null);
  const [displayColumns, setDisplayColumns] = React.useState<any>(columns);
  const [gridRecord, setGridRecord] = React.useState<GridRowModel[]>([]);
  const moduleName = NodWereHouseRoute.title;
  const pageHeading = NodWereHouseRoute.subRoutes
    ? NodWereHouseRoute.subRoutes[5].title
    : "Page Title";
  const [loader, setLoader] = useState(false);
  const [loader2, setLoader2] = useState<any>(false);
  const receiptLoader = useAppSelector(gateEntryLoader);
  const dispatch = useDispatch();
  // const [VirList, setVirList] = React.useState<any>([]);
  const [containerList, setContainerList] = React.useState<any>([]);
  const [allContainerList, setAllContainerList] = React.useState<any>([]);
  const [vehicleList, setVehicleList] = React.useState<any>([]);
  const [editList, setEditList] = React.useState<any>({});
  // dialog state removed; using inline editing instead
  const [virNumber, setvirNumber] = React.useState<any[]>([]);
  const [vehicleNumberLength, setVehicleNumberLength] = useState<number>(0);
  const [isEditMode, setisEditMode] = React.useState(false);
  const [editedRows, setEditedRows] = React.useState<Record<string | number, any>>({});
  const [originalRows, setOriginalRows] = React.useState<Record<string | number, any>>({});
  const [isOpenInfoDailog, setIsOpenInfoDailog] = useState<boolean>(false);
  const [isPrintDestuffingDailog, setisPrintDestuffingDailog] = useState<boolean>(false);
  const [isPrintTallySlipDailog, setIsPrintTallySlipDailog] = useState<boolean>(false);
  const wareHouseListing = useAppSelector(selectWareHouseListing);
  const inventoryItemStatusListing = useAppSelector(selectInventoryItemStatusListing) as Array<{
    id: number;
    status: string;
  }>;
  const allShadRows = useAppSelector(selectAllShadList);
  const newShadRow = {
    id: 0,
    name: "Other",
    terminalId: 0,
    createdAt: "",
    createdBy: 0,
    lastModifiedAt: null,
    lastModifiedBy: 0,
    isActive: true,
  };

  const updatedShadRows = [newShadRow, ...allShadRows];
  // inline remarks handling via grid
  // inline edit only; chassis numbers are handled via dialog formik when editing a single row
  const handleInlineChange = (row: any, field: string, value: any) => {
    setGridRecord((prev: any) =>
      prev.map((r: any) => (r.indexNumber === row.indexNumber ? { ...r, [field]: value } : r))
    );
    setEditedRows((prev: any) => {
      const existing = prev[row.indexNumber] || row;
      return {
        ...prev,
        [row.indexNumber]: { ...existing, [field]: value },
      };
    });
  };

  const handleResetRow = (row: any) => {
    const originalRow = originalRows[row.indexNumber];
    if (originalRow) {
      // Reset grid record to original values
      setGridRecord((prev: any) =>
        prev.map((r: any) => (r.indexNumber === row.indexNumber ? { ...originalRow } : r))
      );
      // Remove from edited rows
      setEditedRows((prev: any) => {
        const newEdited = { ...prev };
        delete newEdited[row.indexNumber];
        return newEdited;
      });
    }
  };
  const validationSchema = object({
    statusId: string().required("This field is required."),
    containerNumber: string().required("This field is required."),
    virNumber: string().required("This field is required."),
    destuffDate: string().required("This field is required."),
    destuffCBM: string(),
    destuffPackages: string(),
    destuffWeight: string(),
    destuffPL: string(),
    location: string(),
    indexRemarks: string().required("This field is required."),
  });

  const formik = useFormik({
    initialValues: {
      aisle: "",
      rack: "",
      shelf: "",
      bin: "",
      gatePassId: "",
      virNumber: "",
      containerNumber: "",
      destuffDate: moment().format("YYYY-MM-DDTHH:mm"),
      vehicleNumber: "",
      destuffCBM: "",
      destuffPackages: "",
      destuffWeight: "",
      destuffInvoice: false,
      destuffPL: "",
      location: "",
      indexRemarks: "",
      statusId: "",
      cargoType: "",
      gatePassIds: "",
      vehicleId: "",
      vehicleStatusId: "",
      consignmentType: "",
      vehicleType: "",
      remarks: "",
      entryDateTime: "",
      registrationNumber: "",
      startTime: moment().format("YYYY-MM-DDTHH:mm:ss"),
      chassisNumbers: [""],
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      setLoader2(true);
      const {
        aisle,
        rack,
        shelf,
        bin,
        indexRemarks,
        gatePassId,
        virNumber,
        containerNumber,
        destuffDate,
        vehicleNumber,
        destuffCBM,
        destuffPackages,
        destuffWeight,
        destuffInvoice,
        destuffPL,
        location,
        statusId,
        cargoType,
        chassisNumbers,
      } = values;
      const body = [
        {
          gatePassId: gatePassId,
          virNumber: virNumber,
          containerNumber: containerNumber,
          destuffDate: destuffDate,
          vehicleId: vehicleNumber || 0,
          foundCBM: destuffCBM,
          foundPackages: destuffPackages,
          weight: destuffWeight,
          weightUnit: "1",
          isInvoiceFound: destuffInvoice,
          destuffPL: destuffPL,
          warehouseId: location,
          itemName: indexRemarks,
          indexNumber: editList?.indexNumber,
          name: "destuff",
          isDestuffing: true,
          aisle: aisle,
          rack: rack,
          shelf: shelf,
          bin: bin,
          statusId: statusId,
          cargoType: cargoType,
          chasisList: cargoType === "Cars" ? chassisNumbers.map((chasis) => ({ chasis })) : [],
        },
      ];

      const items = {
        nodInventoryCreateRequest: body,
      };
      try {
        const results = await fetchWrapper.post("create-inventory-nod", items);
        if (results.isSuccess == true) {
          getListing(containerNumber, virNumber);
        }
      } catch (error) {
        setLoader2(false);
      }
      setLoader2(false);
    },
  });

  const CargoTypeOptions = [
    { id: 1, status: "General" },
    { id: 2, status: "DG" },
    { id: 3, status: "Cars" },
  ];
  const getListing = async (containerNumber: string | number, virNo?: string | number | null) => {
    setLoader2(true);
    try {
      const queryVirNo = String(virNo ?? "").trim();
      const url =
        queryVirNo.length > 0
          ? `get-all-containers-indexes/${containerNumber}?virNo=${encodeURIComponent(queryVirNo)}`
          : `get-all-containers-indexes/${containerNumber}`;

      const results = await fetchWrapper.get(url);
      if (results.isSuccess == true) {
        setGridRecord(results?.value?.containerDetails);

        // If user selected container first, backend returns virNo in details; auto-fill it.
        const inferredVirNo =
          results?.value?.containerDetails?.[0]?.virNo ?? results?.value?.virNo ?? "";
        if (inferredVirNo && !String(formik.values.virNumber || "").trim()) {
          formik.setFieldValue("virNumber", inferredVirNo);
        }

        // Store original rows for reset functionality
        const originalData: Record<string | number, any> = {};
        results?.value?.containerDetails?.forEach((row: any) => {
          originalData[row.indexNumber] = { ...row };
        });
        setOriginalRows(originalData);
      }
      setLoader2(false);
      return;
    } catch (error: any) {
      setLoader2(false);
      dispatch(
        addNotificationAction({
          message: error.message,
          options: { variant: "error" },
        })
      );
    }
  };
  const getvirNumber = async (virNo: string) => {
    let results: any = [];
    results = await fetchWrapper.get(`search-vir-number/${virNo}`);
    if (results.isSuccess) {
      setvirNumber(results.value.virList);
    }
    return;
  };
  // removed unused isDirty state
  const getVirListing = async () => {
    setLoader(true);
    try {
      const results = await fetchWrapper.post("get-all-pending-containers", {
        IsGateEntryRequest: false,
      });
      if (results.isSuccess == true) {
        // no-op
      }
      setLoader(false);
      return;
    } catch (error: any) {
      setLoader(false);
      dispatch(
        addNotificationAction({
          message: error.message,
          options: { variant: "error" },
        })
      );
    }
  };

  const getContainerListing = async (vir: string | number) => {
    setLoader(true);
    try {
      const results = await fetchWrapper.post(`get-all-vir-containers/${vir}`, {});
      if (results.isSuccess == true) {
        setContainerList(results.value?.continers);
      }
      setLoader(false);
      return;
    } catch (error: any) {
      setLoader(false);
      dispatch(
        addNotificationAction({
          message: error.message,
          options: { variant: "error" },
        })
      );
    }
  };

  const getVehcileListing = async () => {
    try {
      const results = await fetchWrapper.get("get-all-vehicles-and-containers-for-gate-out");
      if (results.isSuccess == true) {
        setVehicleList(results.value?.vehicleList);
        setAllContainerList(results.value?.containerList || []);
      }
      return;
    } catch (error: any) {
      dispatch(
        addNotificationAction({
          message: error.message,
          options: { variant: "error" },
        })
      );
    }
  };

  const printDestuffingReport = async (isDuplicate: string) => {
    setisPrintDestuffingDailog(false);
    const { gatePassId } = formik.values;
    if (!gatePassId) return;
    const dateTime = moment().format("DD MMM YYYY, HH:mm");
    const fileMetaData = {
      url: `${process.env.REACT_APP_API_URL}/get-destuffing-slip-by-gate-pass-id/${gatePassId}?isDuplicate=${isDuplicate}&printDateTime=${dateTime}`,
      contentType: ".pdf",
      fileName: "destuffing-report.pdf",
    };
    await dispatch(getPrintFile(fileMetaData, dispatch) as any);
  };

  const printTallySlip = async (isDuplicate: string) => {
    setIsPrintTallySlipDailog(false);
    const { gatePassId } = formik.values;
    if (!gatePassId) return;
    const dateTime = moment().format("DD MMM YYYY, HH:mm");
    const fileMetaData = {
      url: `${process.env.REACT_APP_API_URL}/get-tally-slip-by-gate-pass-id/${gatePassId}?isDuplicate=${isDuplicate}&printDateTime=${dateTime}`,
      contentType: ".pdf",
      fileName: "tally-slip.pdf",
    };
    await dispatch(getPrintFile(fileMetaData, dispatch) as any);
  };

  const handlePrintWeighmentSlip = async (row: any) => {
    const gatePassId = Number(formik.values.gatePassId);
    if (!gatePassId) {
      dispatch(
        addNotificationAction({
          message: "Please select a container first.",
          options: { variant: "warning" },
        })
      );
      return;
    }

    const virNo = String(row?.virNo ?? formik.values.virNumber ?? "");
    const indexNo = Number(row?.indexNumber ?? 0);
    // BL No can be alphanumeric (e.g. "ASDFGHJKL349"), so send it as-is
    const blNo = String(row?.blNo ?? "");
    const containerNo = String(row?.containerNo ?? formik.values.containerNumber ?? "");

    try {
      const apiUrl = process.env.REACT_APP_API_URL;
      const fileMetaData = {
        url: `${apiUrl}/get-weighment-slip/${gatePassId}?gatePassId=${gatePassId}&virNo=${encodeURIComponent(
          virNo
        )}&indexNo=${indexNo}&blNo=${encodeURIComponent(blNo)}&containerNo=${encodeURIComponent(
          containerNo
        )}`,
        contentType: ".pdf",
        fileName: "weighment-slip.pdf",
      };
      await dispatch(getPrintFile(fileMetaData, dispatch) as any);
    } catch (error: any) {
      dispatch(
        addNotificationAction({
          message: error.message,
          options: { variant: "error" },
        })
      );
    }
  };

  const handlePrintDestuffingReport = async () => {
    const { gatePassId } = formik.values;
    if (!gatePassId) {
      dispatch(
        addNotificationAction({
          message: "Please select a container first.",
          options: { variant: "warning" },
        })
      );
      return;
    }
    setisPrintDestuffingDailog(true);
  };

  const handlePrintTallySlip = async () => {
    const { gatePassId } = formik.values;
    if (!gatePassId) {
      dispatch(
        addNotificationAction({
          message: "Please select a container first.",
          options: { variant: "warning" },
        })
      );
      return;
    }
    setIsPrintTallySlipDailog(true);
  };

  // dialog submit/close removed
  const handleEditGridItem = (record: any) => {
    setEditList(record);
    formik.setFieldValue("statusId", record?.statusId || "");
    formik.setFieldValue("bin", record?.bin);
    formik.setFieldValue("shelf", record?.shelf);
    formik.setFieldValue("rack", record?.rack);
    formik.setFieldValue("aisle", record?.aisle);
    formik.setFieldValue("destuffCBM", record?.destuffCBM);
    formik.setFieldValue("destuffPackages", record?.destuffPackages);
    formik.setFieldValue("destuffWeight", record?.destuffWeight);
    formik.setFieldValue("destuffPL", record?.destuffPL);
    formik.setFieldValue("destuffPL", record?.destuffPL);
    formik.setFieldValue("indexRemarks", record?.indexRemarks || "");
    formik.setFieldValue("location", record?.locationNameId);
    formik.setFieldValue("destuffInvoice", Boolean(record?.destuffInv));
    const chasisArray = record?.chasisNumbers?.split(",");
    // ✅ Set cargoType
    formik.setFieldValue("cargoType", record?.cargoType || "");

    // // ✅ Set chassisNumbers if cargoType is "Cars"
    // const chassisList = Array.isArray(record?.chasisList)
    //   ? record.chasisList.map((item: any) => item.chasis || "")
    //   : [""];

    formik.setFieldValue("chassisNumbers", chasisArray ? chasisArray : [""]);
  };
  const hasExportData =
    Array.isArray(gridRecord) && gridRecord.some((r: any) => Number(r?.destuffWeight) > 0);

  const exportHandler = async (row: any[] = []) => {
    dispatch(
      addNotificationAction({
        message: "Your download will begin shortly",
        options: { variant: "success" },
      })
    );
    const safeRows = Array.isArray(row) ? row : [];

    const exportedRecords = safeRows
      .filter((data: any) => Number(data?.destuffWeight) > 0)
      .map((data: any) => ({
        "Vir Number": data?.virNo,
        "Container Number": data?.containerNo,
        "Index No": data?.indexNumber,
        "Bill Number": data?.blNo,
        Description: data?.description,
        "Destuff CBM": data?.destuffCBM,
        "Destuff Packages": data?.destuffPackages,
        "Destuff Weight": `${data?.destuffWeight} KG`,
        "Invoice Found": data?.destuffInv == 1 ? "True" : "False",
        "Manifest Weight": `${data?.manifWeight} KG`,
        "Manifest Packages": data?.noOfPackages,
        "Cargo Type": data?.cargoType,
        "Package Type": data?.packageType,
      }));
    return exportedRecords;
  };

  useEffect(() => {
    if (gridRecord.length) {
      const transformedColumns: any = columns.map((column: any) =>
        column.accessorKey === "indexRemarks"
          ? {
              ...column,
              Cell: function customCell({ renderedCellValue, row }: any) {
                return isEditMode ? (
                  row.original?.isOtherRemarksInline || row.original?.indexRemarks === "Other" ? (
                    <TextField
                      size="small"
                      variant="outlined"
                      className={isEditMode ? classes.editableRedBg : ""}
                      placeholder="Enter Remarks"
                      value={row.original?.indexRemarks || ""}
                      onChange={(e) =>
                        handleInlineChange(row.original, "indexRemarks", e.target.value)
                      }
                    />
                  ) : (
                    <CommonAutoCompleteField
                      cssClassName={`customTextField ${isEditMode ? classes.editableRedBg : ""}`}
                      label=""
                      name="indexRemarksInline"
                      optionsType={updatedShadRows}
                      placeholder="Select Remarks"
                      getOptionLabel={(option: any) => option.name || ""}
                      value={
                        updatedShadRows.find(
                          (opt: any) => opt.name === (row.original?.indexRemarks || "")
                        ) || null
                      }
                      onChange={(option: any) => {
                        if (option && option.name === "Other") {
                          handleInlineChange(row.original, "indexRemarks", "");
                          handleInlineChange(row.original, "isOtherRemarksInline", true);
                          return;
                        }
                        if (option) {
                          handleInlineChange(row.original, "indexRemarks", option.name);
                          handleInlineChange(row.original, "isOtherRemarksInline", false);
                        }
                      }}
                    />
                  )
                ) : (
                  <React.Fragment>
                    <Box>
                      <Tooltip title={row.original?.isWeightDone ? "Yes" : "No"}>
                        <span>{renderedCellValue}</span>
                      </Tooltip>
                    </Box>
                  </React.Fragment>
                );
              },
            }
          : column.accessorKey === "locationName"
          ? {
              ...column,
              Cell: function customCell({ row }: any) {
                return isEditMode ? (
                  <CommonAutoCompleteField
                    cssClassName={`customTextField ${isEditMode ? classes.editableRedBg : ""}`}
                    label=""
                    name="locationNameInline"
                    optionsType={wareHouseListing}
                    placeholder="Select Location"
                    getOptionLabel={(option: any) => option.name || ""}
                    value={
                      wareHouseListing?.find(
                        (st: any) => st?.name === row.original?.locationName
                      ) || null
                    }
                    onChange={(option: any) => {
                      if (option) {
                        handleInlineChange(row.original, "locationName", option.name);
                        handleInlineChange(row.original, "locationNameId", option.id);
                      }
                    }}
                  />
                ) : (
                  <>
                    <Tooltip
                      title={[
                        row.original?.locationName ? `Location: ${row.original?.locationName}` : "",
                        row.original?.aisle ? `Aisle: ${row.original?.aisle}` : "",
                        row.original?.rack ? `Rack: ${row.original?.rack}` : "",
                        row.original?.shelf ? `Shelf: ${row.original?.shelf}` : "",
                        row.original?.bin ? `Bin: ${row.original?.bin}` : "",
                      ]
                        .filter(Boolean)
                        .join(" , ")}
                    >
                      <span>
                        {[
                          row.original?.locationName,
                          row.original?.aisle,
                          row.original?.rack,
                          row.original?.shelf,
                          row.original?.bin,
                        ]
                          .filter(Boolean)
                          .join(" - ")}
                      </span>
                    </Tooltip>
                  </>
                );
              },
            }
          : column.accessorKey === "shortCBM"
          ? {
              ...column,
              Cell: function customCell({ row }: any) {
                return (
                  <React.Fragment>
                    <Box>
                      {row.original.manifCBM &&
                        Number(row.original.manifCBM) - Number(row.original.destuffCBM)}
                    </Box>
                  </React.Fragment>
                );
              },
            }
          : column.accessorKey === "shortPackages"
          ? {
              ...column,
              Cell: function customCell({ row }: any) {
                return (
                  <React.Fragment>
                    <Box>
                      {row.original?.manifPackages &&
                        Number(row?.original?.manifPackages) -
                          Number(row?.original?.destuffPackages)}
                    </Box>
                  </React.Fragment>
                );
              },
            }
          : column.accessorKey === "cargoType"
          ? {
              ...column,
              Cell: function customCell({ row }: any) {
                return isEditMode ? (
                  <CommonAutoCompleteField
                    cssClassName={`customTextField ${isEditMode ? classes.editableRedBg : ""}`}
                    label=""
                    name="cargoTypeInline"
                    optionsType={CargoTypeOptions}
                    placeholder="Select Cargo Type"
                    getOptionLabel={(option: any) => option.status || ""}
                    value={
                      CargoTypeOptions.find((opt: any) => opt.status === row.original?.cargoType) ||
                      null
                    }
                    onChange={(option: any) => {
                      if (option && option.status) {
                        handleInlineChange(row.original, "cargoType", option.status);
                        if (String(option.status).toLowerCase() !== "cars") {
                          handleInlineChange(row.original, "chasisNumbers", "");
                        } else if (row.original?.chasisNumbers == null) {
                          handleInlineChange(row.original, "chasisNumbers", "");
                        }
                      }
                    }}
                  />
                ) : (
                  <span>{row.original?.cargoType}</span>
                );
              },
            }
          : column.accessorKey === "chasisNumbers"
          ? {
              ...column,
              Cell: function customCell({ row }: any) {
                const isCars = String(row.original?.cargoType).toLowerCase() === "cars";
                return isEditMode && isCars ? (
                  <TextField
                    size="small"
                    variant="outlined"
                    className={isEditMode ? classes.editableRedBg : ""}
                    value={row.original?.chasisNumbers || ""}
                    onChange={(e) =>
                      handleInlineChange(row.original, "chasisNumbers", e.target.value)
                    }
                  />
                ) : (
                  <span>{isCars ? row.original?.chasisNumbers || "" : ""}</span>
                );
              },
            }
          : column.accessorKey === "shortWeight"
          ? {
              ...column,
              Cell: function customCell({ row }: any) {
                return (
                  <React.Fragment>
                    <Box>
                      {row.original.manifWeight &&
                        Number(row?.original?.manifWeight) - Number(row?.original?.destuffWeight)}
                    </Box>
                  </React.Fragment>
                );
              },
            }
          : column.accessorKey === "statusId"
          ? {
              ...column,
              Cell: function customCell({ row }: any) {
                return isEditMode ? (
                  <CommonAutoCompleteField
                    cssClassName={`customTextField ${isEditMode ? classes.editableRedBg : ""}`}
                    label=""
                    name="statusIdInline"
                    optionsType={inventoryItemStatusListing}
                    placeholder="Select Item Status"
                    getOptionLabel={(option: any) => option.status || ""}
                    value={
                      inventoryItemStatusListing.find(
                        (st: any) => st.id === (row.original?.statusId || 0)
                      ) || null
                    }
                    onChange={(option: any) => {
                      if (option) {
                        handleInlineChange(row.original, "statusId", option.id);
                      }
                    }}
                  />
                ) : (
                  (() => {
                    const match = inventoryItemStatusListing.find(
                      (st: any) => st.id === (row.original?.statusId || 0)
                    );
                    const label = match ? match.status : "";
                    return <span>{label}</span>;
                  })()
                );
              },
            }
          : column.accessorKey === "destuffInv"
          ? {
              ...column,
              Cell: function customCell({ row }: any) {
                return isEditMode ? (
                  <Switch
                    checked={Boolean(row.original?.destuffInv)}
                    onChange={(e) =>
                      handleInlineChange(row.original, "destuffInv", e.target.checked)
                    }
                    color="primary"
                  />
                ) : (
                  <React.Fragment>
                    <Box>{row.original?.destuffInv ? "Invoice Found" : "Invoice Not Found"}</Box>
                  </React.Fragment>
                );
              },
            }
          : column.accessorKey === "destuffCBM" ||
            column.accessorKey === "destuffPackages" ||
            column.accessorKey === "destuffWeight" ||
            column.accessorKey === "destuffPL"
          ? {
              ...column,
              Cell: function customCell({ row }: any) {
                return isEditMode ? (
                  <TextField
                    size="small"
                    variant="outlined"
                    className={isEditMode ? classes.editableRedBg : ""}
                    value={row.original?.[column.accessorKey] || ""}
                    onChange={(e) =>
                      handleInlineChange(row.original, column.accessorKey, e.target.value)
                    }
                  />
                ) : (
                  <span>{row.original?.[column.accessorKey]}</span>
                );
              },
            }
          : column.accessorKey === "printReport"
          ? {
              ...column,
              Cell: function customCell({ row }: any) {
                const hasDestuffWeight = Number(row.original?.destuffWeight) > 0;
                if (!hasDestuffWeight) return null;
                return (
                  <NewCommonButton
                    isDelete={false}
                    onClick={() => {
                      handlePrintWeighmentSlip(row.original);
                    }}
                  >
                    Print
                  </NewCommonButton>
                );
              },
            }
          : column.accessorKey === "reset"
          ? {
              ...column,
              Cell: function customCell({ row }: any) {
                const hasChanges = editedRows[row.original.indexNumber];
                return (
                  <NewCommonButton
                    disable={!hasChanges}
                    onClick={() => {
                      handleResetRow(row.original);
                    }}
                  >
                    Reset
                  </NewCommonButton>
                );
              },
            }
          : column.accessorKey === "actions"
          ? {
              ...column,
              Cell: function customCell({ row }: any) {
                return (
                  <NewCommonButton
                    icon={<Edit />}
                    isDelete={false}
                    onClick={() => {
                      handleEditGridItem(row.original);
                    }}
                  >
                    Edit
                  </NewCommonButton>
                );
              },
            }
          : ![
              "sNo",
              "printReport",
              "blNo",
              "gateInTime",
              "indexNumber",
              "manifCBM",
              "manifPackages",
              "manifWeight",
              "shortCBM",
              "noOfPackages",
              "packageType",
              "consignee",
              "description",
              "markAndNumber",
              "shortPackages",
              "shortWeight",
              "actions",
              "reset",
            ].includes(column.accessorKey)
          ? {
              ...column,
              Cell: function customCell({ row }: any) {
                return isEditMode ? (
                  <TextField
                    size="small"
                    variant="outlined"
                    value={row.original?.[column.accessorKey] ?? ""}
                    onChange={(e) =>
                      handleInlineChange(row.original, column.accessorKey, e.target.value)
                    }
                  />
                ) : (
                  <span>{row.original?.[column.accessorKey]}</span>
                );
              },
            }
          : column
      );

      setDisplayColumns(transformedColumns);
    }
  }, [gridRecord, isEditMode]);
  const handleCloseConfirmationDialog = () => {
    setIsOpenInfoDailog(false);
  };

  useEffect(() => {
    dispatch(getWareHouseListingAction());
    getVirListing();
    getVehcileListing();
    dispatch(getInventoryItemStatusListingAction());
    const getActiveSheds = true;
    dispatch(getAllShads(getActiveSheds));
  }, []);

  return (
    <>
      <Backdrop className={classes.backdrop} open={loader || loader2 || receiptLoader}>
        <CommonLoader />
      </Backdrop>
      <DuplicateReceiptDialog
        isOpen={isPrintTallySlipDailog}
        handleOriginal={() => {
          printTallySlip("0");
        }}
        heading={"Confirmation"}
        handleDuplicate={() => {
          printTallySlip("1");
        }}
        onClose={() => {
          setIsPrintTallySlipDailog(false);
        }}
      >
        Which receipt do you want to print?
      </DuplicateReceiptDialog>
      <DuplicateReceiptDialog
        isOpen={isPrintDestuffingDailog}
        handleOriginal={() => {
          printDestuffingReport("0");
        }}
        heading={"Confirmation"}
        handleDuplicate={() => {
          printDestuffingReport("1");
        }}
        onClose={() => {
          setisPrintDestuffingDailog(false);
        }}
      >
        Which receipt do you want to print?
      </DuplicateReceiptDialog>
      <Box position="relative">
        <CommonDataGridPage
          module={moduleName}
          heading={pageHeading}
          GridDataComp={
            <CommonMaterialGrid
              rows={gridRecord}
              columns={displayColumns}
              defaultPerPageRecord={15}
              loader={loader2}
              height={650}
              isEditMode={isEditMode}
              isExport={hasExportData ? isExport : false}
              filename={`Destuff_Indexes_${Date.now()}`}
              exportHandler={exportHandler}
              topToolbarRightActions={
                !isEditMode && Boolean(formik.values.gatePassId) ? (
                  <>
                    <Button
                      style={{
                        backgroundColor: "#72CA00",
                        color: "#ffffff",
                        marginRight: 8,
                      }}
                      variant="contained"
                      onClick={handlePrintDestuffingReport}
                    >
                      Print Destuff
                    </Button>
                    <Button
                      style={{
                        backgroundColor: "#72CA00",
                        color: "#ffffff",
                        marginRight: 8,
                      }}
                      variant="contained"
                      onClick={handlePrintTallySlip}
                    >
                      Print Tally Slip
                    </Button>
                  </>
                ) : null
              }
              onClickEdit={() => {
                setisEditMode(true);
              }}
              onClickCancel={() => {
                setisEditMode(false);
                setEditedRows({});
              }}
              onClickUpdate={async () => {
                if (!Object.keys(editedRows).length) {
                  setisEditMode(false);
                  return;
                }
                setLoader2(true);
                try {
                  const editedArray: any[] = Object.values(editedRows);
                  // Pre-validate warehouseId exists for all edited rows
                  const invalidLocationRows = editedArray.filter((row: any) => {
                    const byId = row.locationNameId ?? row.locationId ?? row.warehouseId;
                    const byName = row.locationName
                      ? ((wareHouseListing as any[]) || []).find(
                          (w: any) => w.name === row.locationName
                        )?.id
                      : undefined;
                    const candidate = byId ?? byName ?? formik.values.location;
                    return !candidate || Number(candidate) <= 0;
                  });
                  const invalidStatusRows = editedArray.filter((row: any) => {
                    const { statusId } = row;
                    const isValidStatus = (inventoryItemStatusListing as any[]).find(
                      (s: any) => s.id === statusId
                    );
                    return !statusId || !isValidStatus;
                  });
                  const invalidRemarksRows = editedArray.filter((row: any) => {
                    const remarks = row.indexRemarks;
                    return !remarks || remarks.trim() === "";
                  });
                  if (
                    invalidLocationRows.length ||
                    invalidStatusRows.length ||
                    invalidRemarksRows.length
                  ) {
                    const locationIndexes = invalidLocationRows.map((r: any) => r.indexNumber);
                    const statusIndexes = invalidStatusRows.map((r: any) => r.indexNumber);
                    const remarksIndexes = invalidRemarksRows.map((r: any) => r.indexNumber);
                    const allIndexes = [
                      ...new Set([...locationIndexes, ...statusIndexes, ...remarksIndexes]),
                    ].join(", ");

                    let message = "";
                    const issues = [];
                    if (invalidLocationRows.length) issues.push("Location");
                    if (invalidStatusRows.length) issues.push("Item Status");
                    if (invalidRemarksRows.length) issues.push("Remarks");

                    if (issues.length === 1) {
                      message = `Please select a valid ${issues[0]} for index(es): ${allIndexes}`;
                    } else if (issues.length === 2) {
                      message = `Please select valid ${issues.join(
                        " and "
                      )} for index(es): ${allIndexes}`;
                    } else {
                      message = `Please select valid ${issues.slice(0, -1).join(", ")} and ${
                        issues[issues.length - 1]
                      } for index(es): ${allIndexes}`;
                    }

                    dispatch(
                      addNotificationAction({
                        message: message,
                        options: { variant: "warning" },
                      })
                    );
                    setLoader2(false);
                    return;
                  }
                  const payload = Object.values(editedRows).map((row: any) => {
                    const resolvedWarehouseId =
                      row.locationNameId ??
                      row.locationId ??
                      row.warehouseId ??
                      (row.locationName
                        ? ((wareHouseListing as any[]) || []).find(
                            (w: any) => w.name === row.locationName
                          )?.id
                        : undefined) ??
                      formik.values.location ??
                      0;

                    return {
                      gatePassId: formik.values.gatePassId,
                      virNumber: formik.values.virNumber,
                      containerNumber: formik.values.containerNumber,
                      destuffDate: formik.values.destuffDate,
                      vehicleId: formik.values.vehicleNumber || 0,
                      foundCBM: row.destuffCBM,
                      foundPackages: row.destuffPackages,
                      weight: row.destuffWeight,
                      weightUnit: "1",
                      isInvoiceFound: Boolean(row.destuffInv),
                      destuffPL: row.destuffPL,
                      warehouseId: Number(resolvedWarehouseId) || 0,
                      itemName: row.indexRemarks,
                      indexNumber: row.indexNumber,
                      name: "destuff",
                      isDestuffing: true,
                      aisle: row.aisle,
                      rack: row.rack,
                      shelf: row.shelf,
                      bin: row.bin,
                      statusId: Number(row.statusId) || 0,
                      cargoType: row.cargoType,
                      chasisList:
                        row.cargoType === "Cars" && row.chasisNumbers
                          ? String(row.chasisNumbers)
                              .split(",")
                              .map((c: string) => ({ chasis: c.trim() }))
                          : [],
                    };
                  });

                  const items = { nodInventoryCreateRequest: payload };
                  const results = await fetchWrapper.post("create-inventory-nod", items);
                  if (results.isSuccess == true) {
                    await getListing(formik.values.containerNumber, formik.values.virNumber);
                    setEditedRows({});
                    setisEditMode(false);
                  }
                } catch (error: any) {
                  dispatch(
                    addNotificationAction({
                      message: error.message,
                      options: { variant: "error" },
                    })
                  );
                }
                setLoader2(false);
              }}
            />
          }
        >
          <>
            <Grid spacing={2} container direction="row">
              {/* <Grid item xs={12} md={4} lg={4}>
              <Box>
                <CommonAutoCompleteField
                  required
                  cssClassName="customTextField"
                  label="VIR Number"
                  name="virNumber"
                  optionsType={VirList}
                  placeholder="Select VIR Number"
                  getOptionLabel={(option: any) => option.id || ""}
                  value={VirList?.find((st: any) => st.id === formik.values.virNumber)}
                  onChange={(option: any) => {
                    formik.setFieldValue("virNumber", option.id);
                    formik.setFieldValue("containerNumber", "");
                    formik.setFieldValue("gatePassId", "");
                    formik.setFieldValue("vehicleNumber", "");
                    setGridRecord([]);
                    getContainerListing(option?.id);
                  }}
                  error={formik.touched.virNumber && Boolean(formik.errors.virNumber)}
                  helperText={formik.touched.virNumber && formik.errors.virNumber}
                />
              </Box>
            </Grid> */}
              <Grid item xs={12} md={4} lg={3}>
                <Box>
                  <CommonAutoCompleteField
                    cssClassName="customTextField"
                    label="VIR Number"
                    placeholder="Select VIR Number"
                    name="virNumber"
                    optionsType={virNumber}
                    getOptionLabel={(option) => option.virNo || ""}
                    // required
                    value={
                      virNumber.find((st: any) => st.virNo === formik.values.virNumber) || null
                    }
                    onChange={(option: any) => {
                      formik.setFieldValue("virNumber", option.virNo);
                      formik.setFieldValue("containerNumber", "");
                      formik.setFieldValue("gatePassId", "");
                      formik.setFieldValue("vehicleNumber", "");
                      getContainerListing(option?.virNo);
                    }}
                    onKeyUp={(e: any) => {
                      setVehicleNumberLength(e.target.value.length);

                      if (e.target.value.length == 2 && vehicleNumberLength < 2) {
                        getvirNumber(e.target.value);
                        return;
                      }
                    }}
                    onKeyDownCapture={(e: any) => {
                      if (/[^A-Za-z0-9\d]/.test(e.key)) e.preventDefault();
                      else formik.handleChange(e);
                    }}
                    onPaste={(e: any) => {
                      if (/[^A-Za-z0-9\d]/.test(e.clipboardData.getData("text"))) {
                        e.preventDefault();
                        return;
                      }

                      if (e.clipboardData.getData("text").length >= 2)
                        getvirNumber(e.clipboardData.getData("text"));
                    }}
                    error={
                      formik.touched.registrationNumber && Boolean(formik.errors.registrationNumber)
                    }
                    helperText={
                      formik.touched.registrationNumber && formik.errors.registrationNumber
                    }
                  />
                </Box>
              </Grid>
              <Grid item xs={12} md={4} lg={3}>
                <Box>
                  <CommonAutoCompleteField
                    required
                    cssClassName="customTextField"
                    label="Container Number"
                    name="containerNumber"
                    optionsType={containerList}
                    placeholder="Select Container Number"
                    getOptionLabel={(option: any) => option.containerNumber || ""}
                    value={containerList?.find(
                      (st: any) => st.containerNumber === formik.values.containerNumber
                    )}
                    handleChange={(v: string) => {
                      const q = String(v || "").trim();
                      // Container-first flow: if VIR is not selected, allow searching containers by typing.
                      // We filter from the global containers list that we already fetch on page load.
                      if (!String(formik.values.virNumber || "").trim()) {
                        if (q.length >= 3) {
                          const upper = q.toUpperCase();
                          const filtered = (allContainerList || [])
                            .filter((c: any) =>
                              String(c?.containerNumber || "")
                                .toUpperCase()
                                .includes(upper)
                            )
                            .slice(0, 50);
                          setContainerList(filtered);
                          return;
                        }

                        // < 3 chars: clear suggestions + grid so user starts fresh
                        setContainerList([]);
                        setGridRecord([]);
                      }
                    }}
                    onChange={(option: any) => {
                      const selectedContainerNumber = option?.containerNumber || "";
                      const selectedGatePassId =
                        option?.gatePassId ?? option?.gateEntryId ?? option?.gatePass ?? "";

                      // If user selected container first, call API without virNo (backend supports it)
                      const currentVirNo = String(formik.values.virNumber || "").trim();
                      if (selectedContainerNumber) {
                        getListing(selectedContainerNumber, currentVirNo || undefined);
                      }

                      formik.setFieldValue("containerNumber", selectedContainerNumber);
                      formik.setFieldValue("gatePassId", selectedGatePassId);
                    }}
                    loading={loader2}
                    error={formik.touched.containerNumber && Boolean(formik.errors.containerNumber)}
                    helperText={formik.touched.containerNumber && formik.errors.containerNumber}
                  />
                </Box>
              </Grid>
              <Grid item xs={12} md={4} lg={3}>
                <Box>
                  <CommonTextFieldDate
                    cssClassName={"customTextField"}
                    outerCss={false}
                    datePickerRef={destuffDatePickerRef}
                    label={"Destuff Date and Time"}
                    name={"destuffDate"}
                    required={true}
                    value={formik.values.destuffDate}
                    onChange={(e: any) => {
                      formik.setFieldValue("destuffDate", e);
                    }}
                    maxDate={moment().format("YYYY-MM-DDTHH:mm")}
                    error={formik.touched.destuffDate && Boolean(formik.errors.destuffDate)}
                    helperText={formik.touched.destuffDate && formik.errors.destuffDate}
                  />
                </Box>
              </Grid>
              <Grid item xs={12} md={4} lg={3}>
                <Box>
                  <CommonAutoCompleteField
                    cssClassName="customTextField"
                    label="Vehicle Number"
                    name="vehicleNumber"
                    optionsType={vehicleList}
                    placeholder="Select Vehicle Number"
                    getOptionLabel={(option: any) => option.vehicleNumber || ""}
                    value={vehicleList?.find(
                      (st: any) => st.vehicleId === formik.values.vehicleNumber
                    )}
                    onChange={(option: any) => {
                      if (option && option.id !== 0) {
                        formik.setFieldValue("vehicleNumber", option.vehicleId);
                      }
                    }}
                    error={formik.touched.vehicleNumber && Boolean(formik.errors.vehicleNumber)}
                    helperText={formik.touched.vehicleNumber && formik.errors.vehicleNumber}
                  />
                </Box>
              </Grid>
            </Grid>
          </>

          {/* <TransitionDialog
          isOpen={isOpenEditDailog}
          handleClose={() => handleCloseEditDialog()}
          heading={`Destuff Index: ${editList.indexNumber}`}
          handleConfirm={() => handleSubmitEditDialog()}
        >
          <Box style={{ marginTop: "10px", marginBottom: "10px", width: "500px" }}>
            <Grid container direction="row" alignItems="center" spacing={2}>
              <Grid item xs={12} md={6}>
                <TextField
                  size="small"
                  fullWidth
                  className="customTextField"
                  variant="outlined"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  label="CBM"
                  name="destuffCBM"
                  id="destuffCBM"
                  placeholder="Enter CBM"
                  value={formik.values.destuffCBM}
                  onChange={(e: any) => {
                    formik.setFieldValue("destuffCBM", e.target.value);
                  }}
                  error={formik.touched.destuffCBM && Boolean(formik.errors.destuffCBM)}
                  helperText={formik.touched.destuffCBM && formik.errors.destuffCBM}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  size="small"
                  fullWidth
                  className="customTextField"
                  variant="outlined"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  label="Found Packages"
                  name="destuffPackages"
                  id="destuffPackages"
                  placeholder="Enter Found Packages"
                  value={formik.values.destuffPackages}
                  onChange={(e: any) => {
                    formik.setFieldValue("destuffPackages", e.target.value);
                  }}
                  error={formik.touched.destuffPackages && Boolean(formik.errors.destuffPackages)}
                  helperText={formik.touched.destuffPackages && formik.errors.destuffPackages}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  size="small"
                  fullWidth
                  className="customTextField"
                  variant="outlined"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  label="Found Weight"
                  name="destuffWeight"
                  id="destuffWeight"
                  placeholder="Enter Found Weight"
                  value={formik.values.destuffWeight}
                  onChange={(e: any) => {
                    formik.setFieldValue("destuffWeight", e.target.value);
                  }}
                  error={formik.touched.destuffWeight && Boolean(formik.errors.destuffWeight)}
                  helperText={formik.touched.destuffWeight && formik.errors.destuffWeight}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  size="small"
                  fullWidth
                  className="customTextField"
                  variant="outlined"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  label="P.L"
                  name="destuffPL"
                  id="destuffPL"
                  placeholder="Enter P.L"
                  value={formik.values.destuffPL}
                  onChange={(e: any) => {
                    formik.setFieldValue("destuffPL", e.target.value);
                  }}
                  error={formik.touched.destuffPL && Boolean(formik.errors.destuffPL)}
                  helperText={formik.touched.destuffPL && formik.errors.destuffPL}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <Box>
                  <CommonAutoCompleteField
                    cssClassName="customTextField"
                    label="Location"
                    name="location"
                    optionsType={wareHouseListing}
                    required
                    placeholder="Select Location"
                    getOptionLabel={(option: any) => option.name || ""}
                    value={wareHouseListing?.find((st: any) => st?.id === formik.values?.location)}
                    onChange={(option: any) => {
                      formik.setFieldValue("location", option?.id);
                    }}
                    error={formik.touched.location && Boolean(formik.errors.location)}
                    helperText={formik.touched.location && formik.errors.location}
                  />
                </Box>
              </Grid>
              <Grid item xs={12} md={6}>
                <Box>
                  <CommonAutoCompleteField
                    cssClassName="customTextField"
                    label="Item Status"
                    placeholder="Select Item Status"
                    name="statusId"
                    optionsType={inventoryItemStatusListing}
                    required
                    getOptionLabel={(option: any) => option.status || ""}
                    value={
                      inventoryItemStatusListing.find(
                        (st: any) => st.id === formik.values.statusId
                      ) || null
                    }
                    onChange={(option: any) => {
                      option && option.id !== 0 ? formik.setFieldValue("statusId", option.id) : "";
                    }}
                    error={formik.touched.statusId && Boolean(formik.errors.statusId)}
                    helperText={formik.touched.statusId && formik.errors.statusId}
                  />
                </Box>
              </Grid>
              <Grid item xs={12} md={6}>
                <Box>
                  <CommonAutoCompleteField
                    cssClassName="customTextField"
                    label="Cargo Type"
                    placeholder="Select Cargo Type"
                    name="cargoType"
                    optionsType={CargoTypeOptions}
                    required
                    getOptionLabel={(option) => option.status || ""}
                    value={
                      CargoTypeOptions.find((opt) => opt.status === formik.values.cargoType) || null
                    }
                    onChange={(option) => {
                      option && option.status
                        ? formik.setFieldValue("cargoType", option.status)
                        : "";
                    }}
                    error={formik.touched.cargoType && Boolean(formik.errors.cargoType)}
                    helperText={formik.touched.cargoType && formik.errors.cargoType}
                  />
                </Box>
              </Grid>
              {formik.values.cargoType === "Cars" && (
                <Grid item xs={12}>
                  {formik.values.chassisNumbers.map((value: string, index: number) => (
                    <Grid
                      container
                      spacing={1}
                      alignItems="center"
                      key={index}
                      style={{ marginBottom: 8 }}
                    >
                      <Grid item xs={9}>
                        <TextField
                          fullWidth
                          size="small"
                          variant="outlined"
                          className="customTextField"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          required={formik.values.cargoType === "Cars"}
                          label={`Chassis Number ${index + 1}`}
                          placeholder={`Enter Chassis Number ${index + 1}`}
                          name={`chassisNumbers[${index}]`}
                          value={value}
                          onChange={(e) => {
                            formik.setFieldValue(`chassisNumbers[${index}]`, e.target.value);
                          }}
                          error={
                            Array.isArray(formik.touched.chassisNumbers) &&
                            formik.touched.chassisNumbers[index] &&
                            Boolean(formik.errors.chassisNumbers?.[index])
                          }
                          helperText={
                            Array.isArray(formik.touched.chassisNumbers) &&
                            formik.touched.chassisNumbers[index] &&
                            formik.errors.chassisNumbers?.[index]
                          }
                        />
                      </Grid>

                      <Grid item xs={1}>
                        {formik.values.chassisNumbers.length > 1 && (
                          <IconButton
                            color="primary"
                            onClick={() => {
                              const updated = [...formik.values.chassisNumbers];

                              updated.splice(index, 1);

                              formik.setFieldValue("chassisNumbers", updated);
                            }}
                            disabled={formik.values.chassisNumbers.length === 1}
                          >
                            <RemoveIcon />
                          </IconButton>
                        )}
                      </Grid>

                      <Grid item xs={1}>
                        {index === formik.values.chassisNumbers.length - 1 && (
                          <IconButton
                            color="primary"
                            onClick={() =>
                              formik.setFieldValue("chassisNumbers", [
                                ...formik.values.chassisNumbers,

                                "",
                              ])
                            }
                          >
                            <AddIcon />
                          </IconButton>
                        )}
                      </Grid>
                    </Grid>
                  ))}
                </Grid>
              )}

              <Grid item xs={12} md={6}>
                <Box>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={Boolean(formik.values.destuffInvoice)}
                        onChange={formik.handleChange}
                        name="destuffInvoice"
                        color="primary"
                      />
                    }
                    label="Is Invoice Found"
                  />
                </Box>
              </Grid>
              {formik.values.location ? (
                <>
                  <Grid item md={12}>
                    <Typography style={{ fontWeight: "bold", fontSize: "15px" }}>
                      Location
                    </Typography>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Box>
                      <TextField
                        className={"customTextField"}
                        size="small"
                        fullWidth
                        variant="outlined"
                        InputLabelProps={{
                          shrink: true,
                        }}
                        label="Aisle"
                        name="aisle"
                        placeholder="Enter Aisle"
                        disabled={false}
                        value={formik.values.aisle}
                        onChange={formik.handleChange}
                        error={formik.touched.aisle && Boolean(formik.errors.aisle)}
                        helperText={formik.touched.aisle && formik.errors.aisle}
                      />
                    </Box>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Box>
                      <TextField
                        className={"customTextField"}
                        size="small"
                        fullWidth
                        variant="outlined"
                        InputLabelProps={{
                          shrink: true,
                        }}
                        label="Rack"
                        name="rack"
                        placeholder="Enter Rack"
                        disabled={false}
                        value={formik.values.rack}
                        onChange={formik.handleChange}
                        error={formik.touched.rack && Boolean(formik.errors.rack)}
                        helperText={formik.touched.rack && formik.errors.rack}
                      />
                    </Box>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Box>
                      <TextField
                        className={"customTextField"}
                        size="small"
                        fullWidth
                        variant="outlined"
                        InputLabelProps={{
                          shrink: true,
                        }}
                        label="Shelf"
                        name="shelf"
                        placeholder="Enter Shelf"
                        disabled={false}
                        value={formik.values.shelf}
                        onChange={formik.handleChange}
                        error={formik.touched.shelf && Boolean(formik.errors.shelf)}
                        helperText={formik.touched.shelf && formik.errors.shelf}
                      />
                    </Box>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Box>
                      <TextField
                        className={"customTextField"}
                        size="small"
                        fullWidth
                        variant="outlined"
                        InputLabelProps={{
                          shrink: true,
                        }}
                        label="Bin"
                        name="bin"
                        placeholder="Enter Bin"
                        disabled={false}
                        value={formik.values.bin}
                        onChange={formik.handleChange}
                        error={formik.touched.bin && Boolean(formik.errors.bin)}
                        helperText={formik.touched.bin && formik.errors.bin}
                      />
                    </Box>
                  </Grid>
                </>
              ) : (
                ""
              )}

              <Grid item xs={12} md={12} style={{ display: isOtherRemarks ? "none" : "block" }}>
                <Box>
                  <CommonAutoCompleteField
                    cssClassName="customTextField"
                    label="Remarks"
                    placeholder="Select Remarks"
                    name="indexRemarks"
                    required
                    optionsType={updatedShadRows}
                    getOptionLabel={(option) => option.name || ""}
                    value={
                      updatedShadRows.find((opt: any) => opt.name === formik.values.indexRemarks) ||
                      null
                    }
                    onChange={(option) => {
                      if (option && option.name == "Other") {
                        setIsOtherRemarks(true);
                        formik.setFieldValue("indexRemarks", "");

                        return;
                      }
                      formik.setFieldValue("indexRemarks", option.name);
                    }}
                    error={formik.touched.indexRemarks && Boolean(formik.errors.indexRemarks)}
                    helperText={formik.touched.indexRemarks && formik.errors.indexRemarks}
                  />
                </Box>
              </Grid>

              <Grid item xs={12} md={12} style={{ display: isOtherRemarks ? "block" : "none" }}>
                <Box>
                  <TextField
                    className={"customTextField"}
                    multiline
                    rows={2}
                    rowsMax={4}
                    size="small"
                    fullWidth
                    variant="outlined"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    label="Remarks"
                    name="indexRemarks"
                    placeholder="Enter Remarks"
                    disabled={false}
                    value={formik.values.indexRemarks}
                    onChange={(e: any) => {
                      formik.setFieldValue("indexRemarks", e.target.value);
                    }}
                    error={formik.touched.indexRemarks && Boolean(formik.errors.indexRemarks)}
                    helperText={formik.touched.indexRemarks && formik.errors.indexRemarks}
                  />
                </Box>
              </Grid>
            </Grid>
          </Box>
        </TransitionDialog> */}
        </CommonDataGridPage>
        <Box
          position="absolute"
          top={35} // aligns vertically with heading
          left={110} // ← aligns after "Destuffing"
          zIndex={10}
        >
          <Tooltip title="Containers info">
            <IconButton size="small" onClick={() => setIsOpenInfoDailog(true)}>
              <Info fontSize="small" color="primary" />
            </IconButton>
          </Tooltip>
        </Box>
        <TransitionDialog
          isOpen={isOpenInfoDailog}
          handleClose={handleCloseConfirmationDialog}
          heading={"Infomation!"}
          maxWidth="sm"
          isCustomValidate={true}
        >
          <Box>
            <Typography gutterBottom>
              There are two scenarios when searching containers using a <b>VIR Number</b>:
            </Typography>

            <Typography gutterBottom>
              <b>1. If containers are displayed</b>
              <br />→ The container has been <b>Gate-In successfully</b> and is available for
              further processing.
            </Typography>

            <Typography gutterBottom>
              <b>2. If containers are NOT displayed</b>
              <br />→ The container may <b>not be Gate-In yet</b> or is currently <b>on Hold</b>.
            </Typography>

            <Typography>
              Please verify the <b>Gate-In status</b> or check if the container is <b>on Hold</b>{" "}
              before proceeding.
            </Typography>
          </Box>
        </TransitionDialog>
      </Box>
    </>
  );
}
